import React  from 'react';
import { HeadLine } from '../../components/common/Headline';
import { jsonState } from '../../DataJsons/Regulations';

export const Regulations = (props) => {
    return(
        <div className="regulations">
            <HeadLine headline="Правила" />

            <div className="container" >
                {jsonState.map( (t) => 
                    <div key={t.id} className="m_b">
                        <h3>{t.headline}</h3>
                        <p>{t.text}</p>
                    </div> 
                )}
            </div>
        </div>
    )
}

